<template>
  <el-popover
    ref="popver-download"
    v-model="show"
    placement="bottom"
    trigger="click"
    @show="onShowEvent"
    @hide="onHideEvent"
  >
    <div slot="reference" class="nav-downloads-wrapper">
      <span style="margin-right:5px;">Downloads</span>
      <svg-icon class-name="nav-file-download" icon-class="file-download" />
      <i class="el-icon-arrow-down icon-arrow-down" style="margin-left:5px;" />
    </div>
    <div v-if="list<=0" class="empty-container">
      <div>
        <img src="@/assets/img/download_empty.png" style="width: 60px;" alt="">
        <div class="empty-tip">
          You have no downloads yet
        </div>
      </div>
    </div>
    <div v-else class="download-list-container">
      <div
        v-for="(item,index) in list"
        :key="item.name"
        class="nav-download-item"
        :class="{
          'border-1': index !== (list.length-1),
          'padding-top-0': index === 0,
          'padding-bottom-0': index === (list.length-1),
        }"
      >
        <div class="nav-download-icon-container">  <svg-icon class-name="dropdown-file-download" icon-class="file-download" /></div>
        <div>
          <div class="nav-download-name">{{ item.task_name }}</div>
          <div class="nav-download-status"><span>Status: </span>
            <span v-show="item.task_status === PENDING" v-loading class="color-1d3a41">
              Downloading<div class="loading-dots">
                <div class="dot" />
                <div class="dot" />
                <div class="dot" />
              </div>
            </span>
            <span v-show="item.task_status === SUCCESS" class="color-blue" @click="onClickDownLoad(item)">Ready to Download</span>
            <span v-show="[FAIL,INITFAIL].includes(item.task_status)" class="color-aaa">Failed</span>
          </div>
        </div>
        <div v-if="item.create_time" class="nav-download-time"><span>{{ item.create_time.split(' ') [0] }}</span><br><span style="text-align: right;">{{ item.create_time.split(' ') [1] }}</span></div>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { fetchDownloadTaskList } from '@/api/layout-index/layout-index'
import { download } from '@/utils/common'
export default {
  name: 'DownloadManage',
  data() {
    this.FAIL = 3
    this.SUCCESS = 2
    this.PENDING = 1
    this.INITFAIL = 0
    return {
      list: [],
      show: false
    }
  },
  // mounted(){
  //   this.$store.watch(
  //     (state) => state.app.showDownloadList,
  //     (newValue, oldValue) => {
  //       // 处理属性变化的逻辑
  //       console.log('属性值变化：', newValue);
  //       if(newValue){
  //         setTimeout(()=>{
  //           this.show = true
  //         }, 300)

  //         // this.$set(this, 'show',true)
  //         // this.show = true
  //       }
  //     }
  //   );
  // },
  // computed:{
  //   show(){
  //     return this.$store.state.app.showDownloadList
  //   }
  // },
  watch: {
    '$store.getters.showDownloadList': {
      handler: function(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.show = true
          }, 300)
        }
      }
    }
  },
  methods: {
    onShowEvent() {
      this.getDownloadList()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.getDownloadList()
      }, 10000)
    },
    onHideEvent() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', false)
    },
    onClickDownLoad(item) {
      if (item.task_status === this.SUCCESS) {
        download(item.file_path, '_blank')
      }
    },
    getDownloadList() {
      fetchDownloadTaskList().then(res => {
        const data = res.data || []
        this.list = data.slice(0, 10)
        const item = this.list.find(item => item.task_status === this.PENDING)
        if (!item) {
          if (this.timer) {
            clearInterval(this.timer)
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.nav-downloads-wrapper{
  display: flex;
  align-items: center;
  color: #7A869E;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}
.nav-downloads-container{
  display: inline-block;

}
.download-list-container{
  max-height: 400px;
  overflow: auto;
  padding-right: 10px;
  &::-webkit-scrollbar-track-piece {
    background: #d3dce6;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #99a9bf;
    border-radius: 20px;
  }
}

.nav-file-download{
  color: #7A869E;
  font-size: 18px;
}
.nav-download-item{
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 12px;
  color: #000;
}

.border-1{
  border-bottom: 1px solid #EDEDED;
}
.nav-download-icon-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #1D3A71;
  .dropdown-file-download{
    font-weight: 700;
    font-size: 19px;
    color: #fff
  }
}
.nav-download-name{
  font-weight: 500;
  line-height: 1.5;
  padding-top: 5px;
  width: 200px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.padding-top-0{
  padding-top: 0;
}
.padding-bottom-0{
  padding-bottom: 0;
}
.nav-download-status{
  font-weight: 400;
}
.nav-download-time{
  margin-left: 20px;
  color: #AAA;
  font-size: 12px;
  text-align: right;
}

.empty-container{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 280px;
  min-height: 250px;
  .empty-tip{
    margin-top: 10px;
    color: #C9C9C9;
    font-size: 15px;
  }
}

.color-blue{
  color: #3855F1;
  font-weight: bold;
  cursor: pointer;
}
.color-1d3a41{
  color: #1D3A71;
  font-weight: bold;
}
.color-aaa{
  color: #dd6161;
  font-weight: bold;
}

.loading-dots {
  display: inline-flex;
  justify-content: center;
}

.dot {
  width: 4px;
  height: 4px;
  background-color: #1D3A71;
  border-radius: 50%;
  margin: 0 5px;
  opacity: 0.4;
  animation: loading-animation 1.5s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loading-animation {
  0% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
}
</style>
